var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocationGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 17,
    viewBox: "0 0 15 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 44907"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.83573 10.1558C6.13538 10.1558 4.76953 8.78999 4.76953 7.08964C4.76953 5.38929 6.13538 4.02344 7.83573 4.02344C9.53608 4.02344 10.9019 5.38929 10.9019 7.08964C10.9019 8.78999 9.53608 10.1558 7.83573 10.1558ZM7.83573 5.41717C6.91587 5.41717 6.16326 6.16978 6.16326 7.08964C6.16326 8.0095 6.91587 8.76211 7.83573 8.76211C8.75559 8.76211 9.50821 8.0095 9.50821 7.08964C9.50821 6.16978 8.75559 5.41717 7.83573 5.41717Z",
    fill: "#A2A2A8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M7.83663 16.0625C7.25126 16.0625 6.66589 15.8395 6.2199 15.3935L2.87495 12.0486C0.143245 9.31686 0.143245 4.85693 2.87495 2.12522C4.21293 0.787239 5.96903 0.0625 7.83663 0.0625C9.70422 0.0625 11.4603 0.787239 12.7983 2.12522C15.53 4.85693 15.53 9.31686 12.7983 12.0486L9.45335 15.3935C9.00736 15.8395 8.42199 16.0625 7.83663 16.0625ZM7.83663 1.45623C6.38715 1.45623 4.96554 2.01372 3.85056 3.10083C1.64847 5.30292 1.64847 8.87086 3.85056 11.0451L7.19551 14.39C7.53 14.7245 8.0875 14.7245 8.44987 14.39L11.7948 11.0451C13.9969 8.84299 13.9969 5.27504 11.7948 3.10083C10.7077 2.01372 9.2861 1.45623 7.83663 1.45623Z",
    fill: "#A2A2A8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationGrey);
export default __webpack_public_path__ + "static/media/location-grey.b7b138a133d6704ed658aa034728887a.svg";
export { ForwardRef as ReactComponent };